import { render, staticRenderFns } from "./ClientFunds.vue?vue&type=template&id=cd302d9e&scoped=true&"
import script from "./ClientFunds.vue?vue&type=script&lang=js&"
export * from "./ClientFunds.vue?vue&type=script&lang=js&"
import style0 from "./ClientFunds.vue?vue&type=style&index=0&id=cd302d9e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd302d9e",
  null
  
)

export default component.exports